import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import { RadarLoaderLarge } from "./ui";
import RoleRoute from "./RoleRoute.jsx";
import { ROLES } from "../lib/roles.js";

function FullscreenLoader() {
  return (
    <div className="min-h-screen bg-background-dark flex items-center justify-center">
      <RadarLoaderLarge />
    </div>
  );
}

/** Redirects to /login if not authenticated. Shows spinner while loading. */
export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullscreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

/**
 * Same as ProtectedRoute but also requires role = 'master'.
 * Kept for backwards compatibility — prefer <RoleRoute allow={[...]}> for new code.
 */
export function MasterRoute({ children }) {
  return <RoleRoute allow={[ROLES.MASTER]}>{children}</RoleRoute>;
}
